import { Text, View } from "react-native";
import { Link } from "ui/gluestack/link";
import ViewMore from "ui/molecules/common/ViewMore";

interface Props {
  title: string;
  details: string[];

  link?: string;
}

export default function DetailCard({ title, details, link }: Props) {
  const content = (
    <View className="bg-background-100 mt-2 p-6 md:p-12 rounded-xl flex-1">
      <View className="flex flex-row justify-between">
        <View className="flex flex-col flex-1">
          <Text className="text-2xl text-typography-900 font-semibold">
            {title}
          </Text>
          <View className="flex flex-row flex-wrap mt-3 gap-2 items-center">
            {details.map((detail, index) => (
              <>
                <Text
                  className="text-typography-700 font-light"
                  key={"defail" + index}
                >
                  {detail}
                </Text>
                {index < details.length - 1 ? (
                  <View
                    key={index}
                    className="mx-3 w-1.5 h-1.5 bg-background-300 rounded-full"
                  ></View>
                ) : null}
              </>
            ))}
          </View>
        </View>

        {link ? (
          <View className="place-content-center">
            <ViewMore
              text={"See more"}
              link={link}
              colour="text-typography-600"
              hideTextOnMobile={true}
            />
          </View>
        ) : null}
      </View>
    </View>
  );

  if (link) {
    return (
      <Link href={link} className="flex w-full">
        {content}
      </Link>
    );
  }

  return content;
}
